import { createContext } from '@direct-frontend/modules-context';

export interface FormsContext {
    /**
     * Флаг, нужно ли блокировать форму (отключать взаимодействие) во время submit
     */
    shouldDisableFormOnSubmit?: boolean;

    /**
     * Флаг, нужно ли запретить `Form` реинициализировать уже проинициализированную форму.
     * Используется тестовым декоратором `withFormInitialization`, который сам задаёт
     * начальные значения через `createTestForm` — без этого флага `Form` на маунте
     * перетёр бы их своим `initialValue`.
     */
    shouldBlockReinitialization?: boolean;
}

export type FormsContextInput = FormsContext;

const defaultValue: FormsContext = {
    shouldDisableFormOnSubmit: false,
    shouldBlockReinitialization: false,
};

export const {
    getContext: getFormsContext,
    setContext,
    isContextInitialized: isFormsContextInitialized,
} = createContext<FormsContext>({
    name: '@adv-frontend/form-kit',
    getInitialValue() {
        return defaultValue;
    },
});

export function setFormsContext(context: FormsContextInput) {
    setContext(context);
}
